export default __webpack_public_path__ + "static/media/close.46f6192e.svg";